/* Vibraya additions on top of the base engine in theme.js:
   image tickers, the product quantity stepper and the sticky add to cart. */
(function () {
  'use strict';

  // Duration is exposed as a CSS variable as well as set inline, because the
  // reduced-motion rule in components.css forces every animation to 0.01ms
  // with !important. vibraya-fixes.css reads the variable back with
  // !important so the ticker keeps its slow pace instead of strobing.
  function paceTicker(root) {
    var track = root.querySelector('[data-ticker-track]');
    if (!track) return;
    var pps = parseFloat(root.dataset.speed) || 15;
    var travel = track.getBoundingClientRect().width / 2;
    if (!travel) return;
    var seconds = (travel / pps).toFixed(2) + 's';
    track.style.animationDuration = seconds;
    track.style.setProperty('--ticker-duration', seconds);
  }

  function initTickers() {
    document.querySelectorAll('[data-ticker]').forEach(function (root) {
      var track = root.querySelector('[data-ticker-track]');
      if (!track) return;
      if (track.dataset.cloned !== 'true') {
        track.innerHTML += track.innerHTML;
        track.dataset.cloned = 'true';
      }
      paceTicker(root);
    });
  }

  // The visible stepper has no name attribute; it writes into the form's
  // hidden quantity input, which is what theme.js actually submits.
  function syncQty(box) {
    var input = box.querySelector('[data-qty-input]');
    var form = box.closest('form');
    var hidden = form && form.querySelector('input[type="hidden"][name="quantity"]');
    if (input && hidden) hidden.value = Math.max(1, parseInt(input.value, 10) || 1);
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var box = step.closest('[data-qty]');
      var input = box && box.querySelector('[data-qty-input]');
      if (!input) return;
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
      syncQty(box);
      return;
    }

    // Selecting a bundle resets the hidden quantity to 1 in theme.js; this
    // listener runs after it and puts the stepper's value back.
    if (e.target.closest('[data-variant-option]')) {
      document.querySelectorAll('[data-qty]').forEach(syncQty);
    }

    if (e.target.closest('[data-sticky-submit]')) {
      var form = document.querySelector('form.js-product-form');
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit();
      else form.querySelector('[type="submit"]').click();
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) syncQty(input.closest('[data-qty]'));
  });

  function initSticky() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(anchor);
  }

  function init() {
    initTickers();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Images change the track width once they load, so re-pace then.
  window.addEventListener('load', function () {
    document.querySelectorAll('[data-ticker]').forEach(paceTicker);
  });
  document.addEventListener('shopify:section:load', init);
})();